










import { defineComponent } from '@nuxtjs/composition-api'
import { navigationSectionProps } from '@/mixins/navigationSectionProps'

export default defineComponent({
  name: 'NavigationSectionDefault',
  mixins: [navigationSectionProps],
  setup() {},
})
